var _defs, _text, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProalgenixLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #bc4b51;\n      }\n\n      .st1 {\n        font-family: CooperBlack, 'Cooper Black';\n        font-size: 109.74px;\n      }\n\n      .st2 {\n        fill: #3da35d;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(143.76 813.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st0",
    x: 0,
    y: 0
  }, "PRO"), /*#__PURE__*/React.createElement("tspan", {
    className: "st2",
    x: 245.68,
    y: 0
  }, "ALGENIX"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.94,297.68s-105.12-91.06-235.87-30.35c0,0-148.63,79.12-83.66,224.01,0,0,36.96,85.77,163.04,10.26l23.35,17.88s-121.41,73.22-172.78,57.63c0,0-112.07-29.61-65.37-193.05,0,0,23.35-112.07,168.11-149.43,0,0,116.84-28.02,203.18,63.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.87,491.35s-26.53-55.91,15.5-79.25c0,0,28.02-14.01,65.37,23.35l74.71,65.37s32.69,32.69,56.04,42.03c0,0,74.71,32.69,107.4-23.35,0,0,33.44-52.39-7.79-72.18-7.56-3.63-15.99-5-24.37-4.62-19.2.86-60.48,7.1-103.15,41.43l11.57,14.36,42.03-23.35s30.21-19.23,56.94-17.66c15.13.89,27.06,13.64,26.34,28.78-.83,17.5-13.06,41.15-69.27,49.58,0,0-43.65-2.43-89.53-54.92l-50.55-57.15s-56.04-84.05-102.73-56.04c0,0-60.71,42.03-8.49,123.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 421.79,
    cy: 456.07,
    rx: 30.02,
    ry: 30.78,
    transform: "translate(-170.24 644.24) rotate(-64.87)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 674.33,
    cy: 489.95,
    rx: 21.9,
    ry: 21.25,
    transform: "translate(-132.64 281.2) rotate(-21.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 482.04,
    cy: 486.35,
    rx: 16.75,
    ry: 16.25,
    transform: "translate(-144.61 210.28) rotate(-21.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 626.79,
    cy: 500.36,
    rx: 13.54,
    ry: 13.13,
    transform: "translate(-139.75 264.46) rotate(-21.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M623.18,297.68s-27.22,127.46,107.09,135.1l-2.02-2.02s-18.68-51.37-56.04-74.71c0,0,63.54,9.13,65.29,81.05,8.17,15.97,32.05,78.43-44.28,154.76,0,0-102.73,98.06-233.48,28.02l-81.72,7s132.34,130.75,308.99,0c0,0,78.59-46.7,73.92-177.45,0,0,11.67-142.42-137.75-151.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProalgenixLogo);
export default __webpack_public_path__ + "static/media/Proalgenix Logo.db892dc60e5e036421b0fa9616861103.svg";
export { ForwardRef as ReactComponent };